module.exports = __webpack_public_path__ + "star.svg?e5823a1722f462e2bf7b83e6182a9f14";